import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { DotButton, useDotButton } from './EmblaCarouselDotButton'
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from './usePrevNextButtons'
import * as Styled from './Carousel.styles'

const Carousel = ({ children, isMobile, carouselLayout, boxShadow }) => {
  let hasBoxShadow = boxShadow
  if (!hasBoxShadow) {
    hasBoxShadow = children.some((c) => !!c?.props?.packageData)
  }

  const [emblaRef, emblaApi] = useEmblaCarousel({
    containScroll: 'trimSnaps',
    loop: false,
    align: 'start',
  })

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi)

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi)

  return (
    <Styled.Container
      className="embla"
      isMobile={isMobile}
      carouselLayout={carouselLayout}
      boxShadow={hasBoxShadow}
    >
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {React.Children.map(children, (child) => (
            <div className="embla__slide" key={child?.key}>
              <div className="embla__slide__number">{child}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="embla__controls">
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>

        <div className="embla__dots">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={_}
              onClick={() => onDotButtonClick(index)}
              className={'embla__dot'.concat(
                index === selectedIndex ? ' embla__dot--selected' : ''
              )}
            />
          ))}
        </div>
      </div>
    </Styled.Container>
  )
}

export default Carousel
